// Body-only timeline of every version set in the project. Rendered as a
// tab body inside `VersionSetsModal` (the framing — backdrop, header, close
// button — lives there). Older standalone-modal usage was retired when the
// VERSION SETS button replaced the separate DELETED / PUBLISH LOG buttons.

import React from 'react';
import { useStore } from '../store/useStore';
import styles from './PublishLog.module.css';

function fmtDate(str) {
  if (!str) return null;
  // Accepts both "2024-01-15" and full ISO timestamps
  const d = new Date(str);
  return isNaN(d.getTime()) ? null : d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

export default function PublishLog() {
  const { versionSets } = useStore();

  // Sort newest first
  const sorted = [...versionSets].sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at)
  );

  if (sorted.length === 0) {
    return (
      <div className={styles.empty}>
        <p className={styles.emptyText}>No version sets published yet</p>
        <p className={styles.emptyHint}>
          Version sets are created when drawings are uploaded. They will appear here as a publication timeline.
        </p>
      </div>
    );
  }

  return (
    <div className={styles.timeline}>
      {sorted.map((vs, idx) => (
        <div key={vs.id} className={styles.entry}>
          <div className={styles.entryLeft}>
            <div className={`${styles.dot} ${idx === 0 ? styles.dotLatest : ''}`} />
            {idx < sorted.length - 1 && <div className={styles.line} />}
          </div>
          <div className={styles.entryBody}>
            <div className={styles.entryName}>{vs.name}</div>
            <div className={styles.entryMeta}>
              <span>{vs.sheet_count ?? 0} sheet{vs.sheet_count !== 1 ? 's' : ''}</span>
              {vs.issuance_date && fmtDate(vs.issuance_date) && (
                <>
                  <span className={styles.metaSep}>·</span>
                  <span>Issuance {fmtDate(vs.issuance_date)}</span>
                </>
              )}
              <span className={styles.metaSep}>·</span>
              <span className={styles.metaDate}>
                Added {fmtDate(vs.created_at)}
              </span>
            </div>
            {vs.description && (
              <div className={styles.entryDesc}>{vs.description}</div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
